import { z } from 'zod';

/**
 * Zod schema for validating guest form values
 */
export const guestFormSchema = z
  .object({
    firstName: z.string().trim().min(1, 'First name is required'),
    lastName: z.string().trim().min(1, 'Last name is required'),
    email: z.string().trim().email('Please enter a valid email address'),
    visitDate: z.string().min(1, 'Date of visit is required'),
    reasonForVisit: z.string().trim().min(1, 'Reason for visit is required'),
    acknowledgment: z.boolean().refine((val) => val === true, {
      message: 'You must acknowledge responsibility for your guests',
    }),
  })
  .superRefine((value) => {
    // Validate visit date is not in the future (optional business rule)
    // We'll allow any date for now, but this can be adjusted if needed
    if (value.visitDate) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Optional: Uncomment to prevent future dates
      // if (visitDate > today) {
      //   ctx.addIssue({
      //     path: ['visitDate'],
      //     code: z.ZodIssueCode.custom,
      //     message: 'Visit date cannot be in the future',
      //   });
      // }
    }
  });


